import { Handle, Position } from "@xyflow/react";
import React from "react";
import { Header } from "build-ts/metadata";
import { ColumnType, MetadataTypeEnum } from "build-ts/enums";
import { MdBarChart, MdNumbers } from "react-icons/md";
import { FiCalendar } from "react-icons/fi";
import { PiTarget } from "react-icons/pi";
import { Icon } from "@chakra-ui/react";
import { FaChartPie } from "react-icons/fa";

interface CustomNodeData{
    header: Header;
    style: React.CSSProperties;
}

interface ICustomNodeProps {
    data: CustomNodeData;
    selected?: boolean;
}

export const findNodeColor = (header: Header) => {
    if(!header) return "null";

    if(header.type === MetadataTypeEnum.METRIC){
        return "var(--chakra-colors-purple-700)";
    }
    else if(header.type === MetadataTypeEnum.BENCHMARK){
        return "var(--chakra-colors-orange-500)";
    }
    else if(header.type === MetadataTypeEnum.KG_COLUMN && header.column_type === ColumnType.ATTRIBUTE){
        return "var(--chakra-colors-blue-600)";
    }
    else if(header.type === MetadataTypeEnum.KG_COLUMN && header.column_type === ColumnType.MEASURE){
        return "var(--chakra-colors-green-600)";
    }
    else if(header.type === MetadataTypeEnum.KG_COLUMN && header.column_type === ColumnType.TEMPORAL){
        return "var(--chakra-colors-yellow-600)";
    }
};

const getNodeIcon = (header: Header) => {
    if(!header) return null;

    if(header.type === MetadataTypeEnum.METRIC){
        return <Icon as={MdBarChart} boxSize={9} color="white" />;
    }
    else if(header.type === MetadataTypeEnum.BENCHMARK){
        return <Icon as={PiTarget} boxSize={9} color="white" />;
    }
    else if(header.type === MetadataTypeEnum.KG_COLUMN && header.column_type === ColumnType.ATTRIBUTE){
        return <Icon as={FaChartPie } boxSize={9} color="white" />;
    }
    else if(header.type === MetadataTypeEnum.KG_COLUMN && header.column_type === ColumnType.MEASURE){
        return <Icon as={MdNumbers} boxSize={9} color="white" />;
    }
    else if(header.type === MetadataTypeEnum.KG_COLUMN && header.column_type === ColumnType.TEMPORAL){
        return <Icon as={FiCalendar} boxSize={9} color="white" />;
    }
    return null;
};
const KnowledgeGraphNode : React.FC<ICustomNodeProps> = ({ data, selected }: ICustomNodeProps) => {

    return(
        <div
            style={{
                border: selected ? "2px solid rgba(240, 232, 243, 0.51)" : `2px solid ${findNodeColor(data.header)}`,
                borderRadius: "12px",
                background: findNodeColor(data.header) || data?.style?.background,
                color: "white",
                textAlign: "center",
                minWidth: "100px",
                minHeight: "30px",
                padding: data?.style?.padding || "8px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
          <div 
            style={{
                fontSize: "1.8rem", 
                fontWeight: "600",
                fontFamily: "inherit",
                margin: "5px 10px 5px 10px",
                display: "flex",
                alignItems: "center",
                gap: "10px"
            }}>
                {getNodeIcon(data.header)}
                {data?.header?.name || "No Label"}
            </div>
            <Handle type="target" position={Position.Top} />
            <Handle type="source" position={Position.Bottom} />
        </div>
    );
};

export default KnowledgeGraphNode;